

















































import { Component } from "vue-property-decorator";
import {
  email,
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import ErrorController from "@/resources/mixins/errorController/errorController";
@Component({})
export default class PinLoginComponent extends mixins(
  NotificationEvent,
  ErrorController
) {
  loading = false;
  retryLoading = false;
  @Validate({ required, email })
  email = localStorage.getItem("email");
  @Validate({ required, minLength: minLength(4), maxLength: maxLength(4) })
  pinPassword = "";
  onSendRequestPinLogin(): void {
    this.loading = true;
    this.$store.dispatch("AuthStore/authenticationPinAction", {
      data: { email: this.email, pin: this.pinPassword },
      callback: (response) => {
        localStorage.setItem("email", this.email.toLowerCase());
        this.loading = false;
        location.reload();
      },
      callbackError: (error) => {
        let message = "";
        this.loading = false;
        if (error.response && error.response.status == 401) {
          if (error.response.data.message.includes("Invalid credentials")) {
            message = "notifications.descriptions.pinInvalidCredentials";
          }
          if (error.response.data.message.includes("Request a pin")) {
            message = "notifications.descriptions.pinRequestApin";
          }
          if (error.response.data.message.includes("Pin has expired.")) {
            message = "notifications.descriptions.pinExpired";
          }
          if (error.response.data.message.includes("exceeded")) {
            message = "notifications.descriptions.pinExceeded";
          }
          this.onError("", i18n.t(message));
          return;
        }
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });
  }
  onSendRequestPin(): void {
    this.retryLoading = true;
    this.$store.dispatch("AuthStore/requestPinAction", {
      data: { email: this.email },
      callback: (response) => {
        this.retryLoading = false;
        let message = "";
        if (response.data.message.includes("Email has been sent")) {
          message = "notifications.descriptions.pinRequest";
          this.onSuccess("", i18n.t(message));
        }
        if (response.data.message.includes("user does not exist")) {
          message = "notifications.descriptions.pinErrorUserNotExist";
          this.onError("", i18n.t(message));
          return;
        }
        localStorage.setItem("email", this.email.toLowerCase());
        //this.$router.push({ name: "auth-pin-login" });
      },
      callbackError: (error) => {
        this.retryLoading = false;
        if (error.response && error.response.status == 401)
          this.checkError(error);
        else
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
      },
    });
  }
}
